module.exports = __webpack_public_path__ + "img/f617d2914fcf15a2ac532678b3762281.svg";